<base-support-modal 
		[title]="'Дублирование сайта'" 
		[btnOkClass]="'btn-warning'"
		[btnOkLabel]="'Дублировать'"
		[isBtnOkActive]="isBtnOkActive"
		(onOk)="ok()" >
	<p *ngIf="!isBtnOkActive"><ngb-progressbar type="warning" [value]="100" [striped]="true" [animated]="true"><i>Пожалуйста, не закрывайте это окно</i></ngb-progressbar></p>
	
	<div class="form-group">
		<label class="control-label">Сайт</label>
		<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="url" class="form-control" readonly="readonly">
	</div>	
	
	<hr>
	
	<div class="form-group">	
		<label>Новый домен</label>
		<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="domain" class="form-control">
	</div>
	
	<div class="form-group">
		<label>E-mail</label>
		<input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="email" class="form-control">
	</div>
</base-support-modal>
